import add from 'images/icon/add_white.svg';
import * as React from 'react';
import styled from 'styled-components';
import { DefaultImage } from '../../styles/global/css/GlobalImage';
import { GreySidely3, SidelyBlack } from '../../styles/global/css/Utils';

const AddStyle = styled(DefaultImage) <{ size?: string, disabled?: boolean }>`
    background-color: ${p => p.disabled ? GreySidely3 : SidelyBlack};
    cursor: ${p => p.disabled ? 'not-allowed' : 'pointer'};
    height: ${p => p.size ?? '18px'};
    width: ${p => p.size ?? '18px'};
    border-radius: 50%;
	flex-shrink: 0;
`;

interface AddProps {
	size?: number | string,
	disabled?: boolean,
}

export default function Add({ ...rootDOMAttributes }, props: AddProps) {
	let inner_size: string | undefined;

	if (typeof props.size === 'number') {
		inner_size = `${props.size} + px`;
	} else {
		inner_size = props.size;
	}

	return <AddStyle size={inner_size} {...rootDOMAttributes} src={add} />;
}
